export const suppliers = [
  {
    id: "s1",
    name: "Al Futtaim Industrial Group",
    country: "UAE",
    city: "Dubai",
    verified: true,
    dropshipping: true,
    productCount: 1240,
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    categories: ["Electronics", "Machinery", "Auto Parts"],
    logo: "https://public.readdy.ai/ai/img_res/7cbbe914d91a0fce1247d78fb0629254.jpg",
    established: 2008,
    employees: "500-1000",
    description: "Leading industrial supplier in Dubai with 15+ years of manufacturing excellence.",
  },
  {
    id: "s2",
    name: "Saudi Star Manufacturing Co.",
    country: "Saudi Arabia",
    city: "Riyadh",
    verified: true,
    dropshipping: false,
    productCount: 870,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    categories: ["Textiles", "Furniture", "Home Decor"],
    logo: "https://readdy.ai/api/search-image?query=elegant%20manufacturing%20company%20logo%20gold%20star%20emblem%20white%20background%20Saudi%20Arabia%20corporate%20identity&width=80&height=80&seq=sup2&orientation=squarish",
    established: 2012,
    employees: "200-500",
    description: "Premium textile and furniture manufacturer serving global markets from Riyadh.",
  },
  {
    id: "s3",
    name: "Qatar Premium Exports LLC",
    country: "Qatar",
    city: "Doha",
    verified: true,
    dropshipping: true,
    productCount: 560,
    rating: 4.7,
    responseRate: "92%",
    onTimeDelivery: "96%",
    categories: ["Food & Beverage", "Packaging", "Chemicals"],
    logo: "https://readdy.ai/api/search-image?query=premium%20export%20company%20logo%20gold%20crescent%20emblem%20white%20background%20Qatar%20corporate%20branding&width=80&height=80&seq=sup3&orientation=squarish",
    established: 2015,
    employees: "100-200",
    description: "Qatar-based exporter specializing in food-grade packaging and chemical products.",
  },
  {
    id: "s4",
    name: "Dubai Tech Solutions FZE",
    country: "UAE",
    city: "Dubai",
    verified: true,
    dropshipping: true,
    productCount: 2100,
    rating: 4.9,
    responseRate: "99%",
    onTimeDelivery: "98%",
    categories: ["Electronics", "Smart Devices", "Accessories"],
    logo: "https://readdy.ai/api/search-image?query=tech%20company%20logo%20gold%20circuit%20emblem%20white%20background%20Dubai%20technology%20corporate%20identity%20minimalist&width=80&height=80&seq=sup4&orientation=squarish",
    established: 2010,
    employees: "1000+",
    description: "Top-tier electronics manufacturer in Dubai Free Zone with global dropshipping.",
  },
  {
    id: "s5",
    name: "Jeddah Garment Factory",
    country: "Saudi Arabia",
    city: "Jeddah",
    verified: false,
    dropshipping: true,
    productCount: 340,
    rating: 4.3,
    responseRate: "85%",
    onTimeDelivery: "88%",
    categories: ["Clothing", "Sportswear", "Uniforms"],
    logo: "https://readdy.ai/api/search-image?query=garment%20factory%20logo%20gold%20needle%20thread%20emblem%20white%20background%20Saudi%20Arabia%20fashion%20manufacturing&width=80&height=80&seq=sup5&orientation=squarish",
    established: 2018,
    employees: "50-100",
    description: "Affordable garment manufacturer offering custom uniforms and sportswear.",
  },
  {
    id: "s6",
    name: "Doha Steel & Metal Works",
    country: "Qatar",
    city: "Doha",
    verified: true,
    dropshipping: false,
    productCount: 420,
    rating: 4.6,
    responseRate: "90%",
    onTimeDelivery: "93%",
    categories: ["Steel", "Metal", "Construction"],
    logo: "https://readdy.ai/api/search-image?query=steel%20metal%20works%20company%20logo%20gold%20industrial%20emblem%20white%20background%20Qatar%20construction%20manufacturing&width=80&height=80&seq=sup6&orientation=squarish",
    established: 2005,
    employees: "200-500",
    description: "Heavy-duty steel and metal fabrication for construction and industrial projects.",
  },
];

export const countryStats = [
  {
    country: "UAE - Dubai",
    flag: "🇦🇪",
    supplierCount: 12400,
    categories: 180,
    dropshippingPercent: 72,
    image: "https://readdy.ai/api/search-image?query=Dubai%20skyline%20golden%20hour%20Burj%20Khalifa%20modern%20architecture%20aerial%20view%20luxury%20city%20panorama&width=600&height=400&seq=country1&orientation=landscape",
    path: "/dubai",
  },
  {
    country: "Saudi Arabia",
    flag: "🇸🇦",
    supplierCount: 8900,
    categories: 145,
    dropshippingPercent: 58,
    image: "https://readdy.ai/api/search-image?query=Saudi%20Arabia%20Riyadh%20modern%20skyline%20golden%20sunset%20Kingdom%20Tower%20cityscape%20panoramic%20view&width=600&height=400&seq=country2&orientation=landscape",
    path: "/saudi-arabia",
  },
  {
    country: "Qatar",
    flag: "🇶🇦",
    supplierCount: 4200,
    categories: 98,
    dropshippingPercent: 65,
    image: "https://readdy.ai/api/search-image?query=Qatar%20Doha%20skyline%20West%20Bay%20golden%20hour%20modern%20towers%20waterfront%20panoramic%20cityscape&width=600&height=400&seq=country3&orientation=landscape",
    path: "/qatar",
  },
  {
    country: "Turkey",
    flag: "🇹🇷",
    supplierCount: 18000,
    categories: 190,
    dropshippingPercent: 62,
    image: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20modern%20industrial%20district%20Bosphorus%20bridge%20golden%20hour%20manufacturing%20hub&width=600&height=400&seq=country6&orientation=landscape",
    path: "/products?country=turkey",
  },
];
